import { withJsonFormsControlProps } from "@jsonforms/react";
import SliderField from "./SliderFeild";

const SliderComponent = (props) => {
  const { handleChange, label, data, path, errors, schema, uischema, required } =
    props;
  return (
    <SliderField
      value={data}
      label={label}
      updateValue={(newVal) => handleChange(path, newVal)}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
    />
  );
};

export const SliderControl = withJsonFormsControlProps(SliderComponent);
